export const getAllCustomers = '/users/get-customer';
